import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=ad71d520&scoped=true&lang=pug&"
import script from "./Return.vue?vue&type=script&lang=js&"
export * from "./Return.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad71d520",
  null
  
)

export default component.exports